import { collection, getDocs, query, where } from 'firebase/firestore';
import { Price, Product } from 'model/Product';
import { db } from "../firebase"

const table = 'products'

export async function findFromServer(): Promise<Product> {
  const productsColRef = collection(db, table)
  const productsColSnap = await getDocs(query(productsColRef, where('active', '==', true)))
  const productDoc = productsColSnap.docs[0]

  const priceColRef = collection(productDoc.ref, 'prices')
  const priceColSnap = await getDocs(query(priceColRef, where('active', '==', true)))
  const prices = priceColSnap.docs.map(priceDoc => {
    const price = priceDoc.data() as Price
    price.id = priceDoc.id
    return price
  })

  const product = productDoc.data() as Product
  product.prices = prices

  return product
}